import _createClass from "@babel/runtime/helpers/createClass";
import _classCallCheck from "@babel/runtime/helpers/classCallCheck";
import _defineProperty from "@babel/runtime/helpers/defineProperty";
/* Базовые настройки для MetricHelper */
import { logger } from "../logger";
/* Базовый класс метрики. Делаем от него extend для своего кастомного класса */
export var RootMetricHelper = /*#__PURE__*/_createClass(function RootMetricHelper(_ref) {
  var _this = this;
  var selector = _ref.selector,
    _ref$debug = _ref.debug,
    debug = _ref$debug === void 0 ? false : _ref$debug;
  _classCallCheck(this, RootMetricHelper);
  _defineProperty(this, "debug", false);
  _defineProperty(this, "_getData", void 0);
  _defineProperty(this, "selector", void 0);
  _defineProperty(this, "getData", function () {
    var _this$selector, _this$_getData;
    if (!_this._getData) {
      logger.warn('You use getData without data. Use withMetricContainer to pass data');
    }
    return (_this$selector = _this.selector) === null || _this$selector === void 0 ? void 0 : _this$selector.call(_this, (_this$_getData = _this._getData) === null || _this$_getData === void 0 ? void 0 : _this$_getData.call(_this));
  });
  /* Геттер статической инфы от браузера */
  _defineProperty(this, "getPageInfo", function () {
    // TODO: добавить проверку window
    return {
      title: document.title,
      url: window.location.href,
      referrer: document.referrer
    };
  });
  _defineProperty(this, "setDataGetter", function (getData) {
    _this._getData = getData;
  });
  this.debug = debug;
  this.selector = selector;
});